module.exports = __webpack_public_path__ + "img/homes.1bcf0bb4.png";